<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {
    this.$auth.onUserAuthChange();
  },
};
</script>

<style lang="scss"></style>
